import 'regenerator-runtime/runtime';
const autoComplete = require("@tarekraafat/autocomplete.js");

$(function() {
	$('.quick-search__button').on('click', function(event) {
		event.preventDefault();
		var wrapper = $(this).parents('.quick-search');
		wrapper.find('.quick-search__input').toggleClass('active');
	});

	$('.quick-search__input .close').on('click', function(event) {
		event.preventDefault();
		var wrapper = $(this).parents('.quick-search');
		wrapper.find('.quick-search__input').toggleClass('active');
		wrapper.find('.quick-search__input input').val('');
	});

	const autoCompleteJS = new autoComplete({
		selector: '.quick-search__input input',
		// placeHolder: 'Znajdź produkt',
		debounce: 300,
		data: {
			src: async function(query) {
				try {
					var wrapper = $('.quick-search');
					wrapper.find('.quick-search__input').addClass('loading');
					var url = wrapper.data('searchUrl');
					var sourceUrl = url + '&phrase=' + query;
					const source = await fetch(sourceUrl);
					console.log(source, url);
	
					const data = await source.json();
					wrapper.find('.quick-search__input').removeClass('loading');
					if(data.posts) {
						return data.posts;
					} else {
						return [];
					}
				} catch(error) {
					return error;
				}
			},
			keys: ['title']
		},
		searchEngine: function(query, record) {
			var result = autoCompleteJS.search(query, record, {
				highlight: true,
			});
			if(!result) {
				return record;
			}
			return result;
		},
		resultsList: {
			maxResults: 999,
			noResults: true,
		},
		resultItem: {
			highlight: true,
			tag: 'li',
			element: function(item, data) {
				console.log(item, 'item');
				console.log(data, 'data');
				var template = '<a href="' + data.value.url + '" class="result-item">' +
					'<span class="result-item__image">' + 
						'<img src="' + data.value.image + '" alt="' + data.value.title + '" />' +
					'</span>' +
					'<span class="result-item__info">' + 
						'<span class="result-item__title">' + data.match + '</span>' + 
						'<span class="result-item__category">' + data.value.category + '</span>' +
					'</span>' +
				'</a>';

				item.innerHTML = template;
			},
		}
	});
});